import { Injectable } from "@angular/core";
import { Observable, Subject, config } from "rxjs";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UtilService } from './util.service';

@Injectable({
  providedIn: "root"
})

export class FundosServices {

    constructor(private http: HttpClient, private util: UtilService){}

    //Lista filtros dos fundos
    public buscaFiltros():Observable<any>{
            return this.http
                       .get(`${environment.apiURL}/Logado/Fundos/ListarFiltros`)
    }

    // lista todos tipos de fundos
    public ListaTiposFundo():Observable<any>{
        return this.http
                   .get(`${environment.apiURL}/Logado/Fundos/ListarFundos`)
    }

    // Lista fundos de acordo com o filtro
    public Listar(anomesInicio,anomesFim,tipoFundo,tipoOrdem):Observable<any>{
        return this.http
                   .get(`${environment.apiURL}/Logado/Fundos/Listar`,{params:{anomesInicio:anomesInicio,anomesFim:anomesFim,tipoFundo:tipoFundo,tipoOrdem:tipoOrdem}})
    }


}
